export const SITE_NAME = "Amparo & Aconchego";

export const DEFAULT_TITLE = `Cuidadores de Idosos no Rio de Janeiro | ${SITE_NAME}`;
export const DEFAULT_DESCRIPTION =
  "Cuidadores de idosos no Rio de Janeiro: home care, acompanhamento hospitalar e cuidado domiciliar. Atendimento humanizado, escala digna e transparência para sua família.";

export const ROUTE_META: Record<
  string,
  { title: string; description: string }
> = {
  "/": {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
  },
  "/servicos": {
    title: `Serviços de Cuidador de Idosos no RJ | ${SITE_NAME}`,
    description:
      "Serviços de cuidador de idosos no RJ: domiciliar, home care, acompanhamento hospitalar, plantões diurnos e noturnos. Soluções completas para sua família.",
  },
  "/como-funciona": {
    title: `Como Funciona | Cuidador de Idosos no RJ | ${SITE_NAME}`,
    description:
      "Como funciona: contato, avaliação gratuita, seleção do cuidador e início do cuidado. Transparência em cada passo para sua família.",
  },
  "/sobre": {
    title: `Sobre Nós | Cuidador de Idosos no RJ | ${SITE_NAME}`,
    description:
      "História e valores do Amparo & Aconchego: clareza, respeito e humanização no cuidado de idosos no Rio de Janeiro.",
  },
  "/para-familias": {
    title: `Para Famílias | Cuidador de Idosos no RJ | ${SITE_NAME}`,
    description:
      "Para famílias: cuidador de idosos no RJ, plantões diurnos e noturnos, escala digna. Perguntas e atendimento humanizado.",
  },
  "/trabalhe-conosco": {
    title: `Trabalhe Conosco | Cuidador de Idosos no RJ | ${SITE_NAME}`,
    description:
      "Vagas para cuidador de idosos no RJ. Escala digna, remuneração adequada e apoio. Envie currículo ou contato pelo WhatsApp.",
  },
  "/contato": {
    title: `Contato | Cuidador de Idosos no RJ | ${SITE_NAME}`,
    description:
      "Contato Amparo e Aconchego: WhatsApp, formulário ou e-mail. Solicitar avaliação gratuita para cuidado de idosos no Rio de Janeiro.",
  },
  "/privacidade": {
    title: `Política de Privacidade | ${SITE_NAME}`,
    description:
      "Política de privacidade e tratamento de dados do Amparo & Aconchego, em conformidade com a LGPD.",
  },
  "/cuidador-de-idosos-rj": {
    title: `Cuidador de Idosos no RJ | ${SITE_NAME}`,
    description:
      "Cuidadores de idosos qualificados no Rio de Janeiro. Atendimento humanizado, escala digna e transparência para sua família.",
  },
  "/home-care-rio-de-janeiro": {
    title: `Home Care no Rio de Janeiro | ${SITE_NAME}`,
    description:
      "Home care no RJ: equipe multidisciplinar, enfermeiros, fisioterapeutas e cuidadores. Serviço completo no conforto do domicílio.",
  },
  "/acompanhamento-hospitalar-rj": {
    title: `Acompanhamento Hospitalar no RJ | ${SITE_NAME}`,
    description:
      "Acompanhamento hospitalar no Rio de Janeiro. Presença qualificada durante internações e procedimentos. Segurança e cuidado.",
  },
};

export function getMetaForPath(pathname: string) {
  return ROUTE_META[pathname] ?? {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
  };
}
